import { connect, useSelector } from "react-redux";
import MembershipDurationForm from "./components/MembershipDurationForm";
import { ApiError } from "components";
import { CreatePackageError } from "modules/membership_plan/commercial_membership_plan/packages/store/actionType";
import { useState, ChangeEvent, FormEvent, useEffect } from "react";
import { createMembershipDuration } from "../../store/action";
import { CreateMembershipDurationInput } from "../../store/actionType";
import { validatePackageForm } from "./components/FormValidation";

type OwnProps = {
  package_id: string;
  closeModal: React.Dispatch<React.SetStateAction<boolean>>;
};
type DispatchProps = ReturnType<typeof mapDispatchToProps>;
type StateProps = ReturnType<typeof mapStateToProps>;
type Props = DispatchProps & OwnProps & StateProps;
const HandleCreateMembershipDuration: React.FC<Props> = ({
  closeModal,
  onCreateMembershipDuration,
  package_id,
}) => {
  const [loading, setLoading] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [formData, setFormData] = useState<CreateMembershipDurationInput>({
    duration_type: "",
    price: "",
    number_of_days: "",
    description: "",
    package_id: "",
    price_usd:""
  });
  const [error, setError] = useState<CreatePackageError>({});
  const [apiError, setApiError] = useState(null);
  const membershipState = useSelector(
    (state: any) =>  state.membershipDuration?.genericMembershipDurationState
  );
  const handleChange = (
    e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    const { name, value, type } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: type ==="number"? Number(value): value,
    }));
    setError((prevErrors) => ({
      ...prevErrors,
      [name]: "",
    }));
  };

  const handleSave = async (e: FormEvent) => {
    e.preventDefault();
    const input = {
      duration_type: formData.duration_type,
      price: formData.price,
      number_of_days: formData.number_of_days,
      description: formData.description,
      package_id: package_id.toString(),
      price_usd:formData.price_usd
    };
    const { isValid, errors } = validatePackageForm(formData);
    setError(errors);

    if (!isValid) return;

    if (
      formData.description.trim() !== "" &&
      formData.duration_type.trim() !== "" &&
      formData.price !== "" &&
      formData.number_of_days !== "" &&
      formData.price_usd !== ""
    ) {
      setSubmitted(true);
      setLoading(true);
      try {
        await onCreateMembershipDuration(input);
      } catch (err) {
        console.error("Failed to create package:", err);
      } finally {
        setLoading(false);
      }
    }
  };
  useEffect(() => {
  if (!membershipState.isLoading && submitted) {
    if (membershipState.status === "SUCCESS") {
      closeModal(false);
      setApiError(null);
      setSubmitted(false);
    }
    if (membershipState.status === "FAILED") {
      setApiError(membershipState.error); 
    }
  }
}, [membershipState.isLoading, membershipState.status, submitted]);
  return (
    <div className="">
      <MembershipDurationForm
        handleSave={handleSave}
        formData={formData}
        handleChange={handleChange}
        error={error}
        loading={loading}
        header={"Create Membership Duration"}
      />
      {apiError && <ApiError>{apiError}</ApiError>}
    </div>
  );
};
const mapStateToProps = (state: any) => {
  return {
    fetchMembershipDurationByPackageId:
      state.membershipDuration?.fetchmembershipDurationState,
  };
};
const mapDispatchToProps = (dispatch: any) => ({
  onCreateMembershipDuration: (input: CreateMembershipDurationInput) =>
    dispatch(createMembershipDuration(input)),
});
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(HandleCreateMembershipDuration);
